import React, { useEffect, useState } from "react";

const NavBar = () => {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  useEffect(() => {
    const scrollHandler = () => {
      updateNavbar(window.scrollY >= 20);
    };

    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  const navigation = [
    { to: "#about", title: "About", mobileTitle: "About" },
    { to: "#skills", title: "Skills", mobileTitle: "Skills" },
    { to: "#experience", title: "Work", mobileTitle: "Work" },
    { to: "#projects", title: "Projects", mobileTitle: "Projects" },
    { to: "#certificates", title: "Certs", mobileTitle: "Certs" },
    { to: "#contact", title: "Contact", mobileTitle: "Contact" },
    { to: "/MuhammadMaaz.pdf", title: "Resume", mobileTitle: "Resume", download: true },
  ];

  const desktopLinks = navigation.filter((item) => !item.download);
  const resumeLink = navigation.find((item) => item.download);

  const onPressNav = () => {
    updateExpanded(false);
  };

  return (
    <nav className={`site-nav ${navColour ? "site-nav-scrolled" : ""}`}>
      <a href="#home" className="site-brand" onClick={onPressNav}>
        M.MAAZ
      </a>

      <div className="site-nav-desktop">
        {desktopLinks.map((item) => (
          <a key={item.to} href={item.to} className="site-nav-link" onClick={onPressNav}>
            {item.title}
          </a>
        ))}
      </div>

      {resumeLink ? (
        <a href={resumeLink.to} download className="site-nav-resume-link" onClick={onPressNav}>
          {resumeLink.title}
        </a>
      ) : null}

      <button type="button" className="site-nav-toggle" aria-label="Toggle navigation menu" aria-expanded={expand} onClick={() => updateExpanded((prev) => !prev)}>
        <span className="site-nav-toggle-line"></span>
        <span className="site-nav-toggle-line"></span>
        <span className="site-nav-toggle-line"></span>
      </button>

      <div className={`site-nav-mobile ${expand ? "site-nav-mobile-open" : ""}`}>
        {navigation.map((item) => (
          <a key={item.to} href={item.to} download={item.download ? true : undefined} className={`site-nav-mobile-link ${item.download ? "site-nav-mobile-resume-link" : ""}`} onClick={onPressNav}>
            {item.mobileTitle}
          </a>
        ))}
      </div>
    </nav>
  );
};

export default NavBar;
